(() => {
  if (customElements.get('dj-home-hero-video')) return;

  class DjHomeHeroVideo extends HTMLElement {
    connectedCallback() {
      this.hero = this.closest('.hero__container');
      this.button = this.querySelector('button');
      this.videos = [...(this.hero?.querySelectorAll('video') || [])];
      if (!this.button || !this.videos.length || this.abort) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.userIntent ??= null;
      this.inView = true;

      this.button.addEventListener('click', () => {
        const current = this.currentVideo();
        this.userIntent = !current || current.paused;
        this.sync();
      }, { signal });
      this.motion.addEventListener('change', () => {
        if (this.motion.matches && this.userIntent !== false) this.userIntent = null;
        this.sync();
      }, { signal });
      this.mobile.addEventListener('change', () => this.sync(), { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      for (const video of this.videos) {
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('play', () => this.updateButton(), { signal });
        video.addEventListener('pause', () => this.updateButton(), { signal });
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this.hero);
      }
      this.button.hidden = false;
      this.sync();
    }

    currentVideo() {
      return this.videos.find(video => video.getClientRects().length && getComputedStyle(video).display !== 'none');
    }

    sync() {
      const current = this.currentVideo();
      const wantsPlay = this.userIntent ?? !this.motion.matches;
      const shouldPlay = wantsPlay && this.inView && !document.hidden;
      for (const video of this.videos) {
        // Never let the browser restart a video independently of user intent.
        video.autoplay = false;
        if (video === current && shouldPlay) {
          const attempt = video.play();
          attempt?.catch(() => {
            if (!this.isConnected) return;
            this.updateButton();
          });
        } else {
          video.pause();
        }
      }
      this.updateButton();
    }

    updateButton() {
      const video = this.currentVideo();
      const playing = !!video && !video.paused;
      this.button.dataset.playing = String(playing);
      const label = playing ? 'Pausa video' : 'Spela video';
      this.button.setAttribute('aria-label', label);
      this.button.title = label;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.videos?.forEach(video => video.pause());
    }
  }

  customElements.define('dj-home-hero-video', DjHomeHeroVideo);
})();
